var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function Check2IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 20.0001V3.99985C2 2.89485 2.89318 2 3.99985 2H20.0001C21.1052 2 22 2.89318 22 3.99985V20.0001C22 21.1052 21.1068 22 20.0001 22H3.99985C2.89485 22 2 21.1068 2 20.0001ZM20.0001 4L4 3.99985L3.99985 20L20 20.0001L20.0001 4ZM9.79289 15.7071L6.79289 12.7071C6.40237 12.3166 6.40237 11.6834 6.79289 11.2929C7.18342 10.9024 7.81658 10.9024 8.20711 11.2929L10.5 13.5999L15.2929 8.79289C15.6834 8.40237 16.3166 8.40237 16.7071 8.79289C17.0976 9.18342 17.0976 9.81658 16.7071 10.2071L11.2071 15.7071C10.8166 16.0976 10.1834 16.0976 9.79289 15.7071Z", fill: "" })));
}
export var Check2Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: Check2IconInner }, props))); };
//# sourceMappingURL=Check2Icon.js.map